/**
 * MailTeamBadge (MV): the ONE team-restriction marker, shared by every surface that lists or
 * opens a mail (Eingang list + reading pane, Ausgang/Gesendet, the client Kommunikation tab).
 * `team` is the name mailTeamMarkerName already trimmed and vouched for; the badge never
 * re-decides whether a restriction exists, it only renders the one it is handed.
 */
import { Users } from 'lucide-react';
import { cn } from '../../../lib/cn';
import { Badge } from '../../../components/ui/Badge';
import { mailTeamTooltip } from '../mail-visibility';

interface MailTeamBadgeProps {
  team: string;
  /** 'sm' = dense rows (list, table, tab), 'md' = the reading-pane header. */
  size?: 'sm' | 'md';
  className?: string;
}

export function MailTeamBadge({ team, size = 'sm', className }: MailTeamBadgeProps) {
  return (
    <Badge
      variant="neutral"
      className={cn('gap-1', size === 'sm' && 'text-[10px]', className)}
      title={mailTeamTooltip(team)}
    >
      <Users className={size === 'sm' ? 'size-2.5' : 'size-3'} />
      {team}
    </Badge>
  );
}
